import * as stylex from "@stylexjs/stylex";
import { foldFigureControl, useFigureState } from "domain/figure-state";
import { Filter24 } from "icons/Filter";
import { useEffect, useState } from "react";
import { breakpoints, colors } from "../materials/consts.stylex";
import { typography } from "../materials/typography.stylex";
import { O, pipe, R } from "../prelude";
import { FigureControls } from "./figure-controls";
const styles = {
    controlsList: {
        kMwMTN: "x196nufh",
        $$css: true
    }
};
export default function MobileControlPanel() {
    const [state] = useFigureState();
    const [isPanelOpen, setIsPanelOpen] = useState(false);
    return <div className="x1n3tk9q xmkeg23 x1y0btm7 x5snjlz x12oqio5 xdj266r x1iymm2a x1tamke2">
      <div className="x78zum5 x1qughib x6s0dn4">
        <div className="x78zum5 x6s0dn4">
          <Filter24/>
          <h1 {...stylex.props(typography.heading3)}>Filters</h1>
        </div>
        <button className="x1xlr1w8 x12klvby x1ypdohk xjbqb8w x78zum5 x6s0dn4 xhr9w20 xt0b8zv x1n5bzlp" onClick={()=>setIsPanelOpen(true)}>
          Edit
        </button>
      </div>
      <div {...stylex.props(typography.table, styles.controlsList)}>
        {pipe(state.controls, O.map((controls)=>R.toArray(controls).filter((c)=>c[1].title).sort(([idA, controlA], [idB, controlB])=>{
            return controlA.position === "LEFT" ? controlB.position === "LEFT" ? idA > idB ? 1 : -1 : -1 : 1;
        }).map(([id, control])=>{
            return foldFigureControl(control, {
                ButtonGroup: (control)=><p>{`${control.title}: ${state.controlItems[id].find((d)=>d.value === control.selected)?.label}`}</p>,
                Checkbox: (control)=><p>
                      {`${control.title}: ${control.selected.toString() === "true" ? control.label : undefined}
                    `}
                    </p>,
                SingleSelect: (control)=><p>
                      {`${control.title}: ${state.controlItems[id].find((d)=>d.value === O.toUndefined(control.selected))?.label ?? "No selection"}`}
                    </p>,
                MultiSelect: (control)=><p>
                      {`${control.title}: ${pipe(control.selected, O.map((selectedValues)=>selectedValues.map((value)=>`${state.controlItems[id].find((d)=>d.value === value)?.label}`).join(", ")), O.getOrElse(()=>"No selection"))}
                    `}
                    </p>,
                Timeline: (control)=><p>{`${control.title}: ${state.controlItems[id].find((d)=>d.value === control.selected.toString())?.label}`}</p>,
                Radio: (control)=><p>
                      {`${control.title}: ${state.controlItems[id].find((d)=>d.value === O.toUndefined(control.selected))?.label ?? "No selection"}`}
                    </p>,
                MultiCheckbox: (control)=><p>
                      {`${control.title}: ${pipe(control.selected, O.map((selectedValues)=>selectedValues.map((value)=>`${state.controlItems[id].find((d)=>d.value === value)?.label}`).join(", ")), O.getOrElse(()=>"No selection"))}
                    `}
                    </p>
            });
        })), O.toNullable)}
      </div>
      {isPanelOpen && <FilterPanel onClose={()=>setIsPanelOpen(false)}/>}
    </div>;
}
const FilterPanel = ({ onClose })=>{
    useEffect(()=>{
        document.body.style.overflow = "hidden";
        return ()=>{
            document.body.style.overflow = "unset";
        };
    }, []);
    return <div className="xzkaem6 xixxii4 x13vifvy xu96u03 x5yr21d xh8yej3 x12peec7">
      <div className="x1n3tk9q xso031l x1q0q8m5 xto54q2 xh8yej3 xejb4zx x78zum5 x1qughib">
        <div className="x78zum5 x6s0dn4">
          <Filter24/>
          <h1 {...stylex.props(typography.heading3)}>Filters</h1>
        </div>
        <button className="x1xlr1w8 x12klvby x1ypdohk xjbqb8w x78zum5 x6s0dn4 xhr9w20 xt0b8zv x1n5bzlp" onClick={onClose}>
          Close
        </button>
      </div>
      <div className="xh8yej3 x78zum5 x1tamke2 xdt5ytf xdjzykv x99ei8s">
        <FigureControls position="LEFT"/>
        <FigureControls position="TOP"/>
        <FigureControls position="RIGHT"/>
      </div>
    </div>;
};
